/* tslint:disable */
/* eslint-disable */
/**
 * pkg/api/binoculars/binoculars.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BinocularsCordonRequest
 */
export interface BinocularsCordonRequest {
    /**
     * 
     * @type {string}
     * @memberof BinocularsCordonRequest
     */
    nodeName?: string;
}

export function BinocularsCordonRequestFromJSON(json: any): BinocularsCordonRequest {
    return BinocularsCordonRequestFromJSONTyped(json, false);
}

export function BinocularsCordonRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): BinocularsCordonRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'nodeName': !exists(json, 'nodeName') ? undefined : json['nodeName'],
    };
}

export function BinocularsCordonRequestToJSON(value?: BinocularsCordonRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'nodeName': value.nodeName,
    };
}

